export const iconFontAwesomeMedicalHealthMaskVentilator = (
	<i className="fa-solid fa-mask-ventilator"></i>
);
